<div class="header">
  <label class="textColour">
    {{ titleText }}
  </label>
</div>

<form [formGroup]="formulaForm">
  <div mat-dialog-content class="dialog-content">
    <!-- BASIC INFO -->
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Formula Name</mat-label>
        <input matInput formControlName="name" required [errorStateMatcher]="errorStateMatcher" />
        <mat-error *ngIf="formulaForm.get('name')?.hasError('required')">
          Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" >
        <mat-label>Formula Type</mat-label>
        <mat-select 
        [errorStateMatcher]="errorStateMatcher"
          formControlName="mode"
          [disabled]="isEditMode"
          (selectionChange)="onModeChange($event.value)"
        >
          <mat-option value="Analytic">SQL</mat-option>
          <mat-option value="Statistical">Statistical</mat-option>
        </mat-select>
      </mat-form-field>


    </div>

    <div class="form-row"  *ngIf="mode === 'Analytic'">
      <mat-form-field appearance="outline" class="full-width" >
        <mat-label>Description</mat-label>
        <textarea matInput rows="2" formControlName="description" [errorStateMatcher]="errorStateMatcher"></textarea>
        <mat-error *ngIf="formulaForm.get('description')?.hasError('required')">
          Description is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- ANALYTICAL MODE -->
    <div [hidden]="mode !== 'Analytic'">
      <h3>SQL Builder</h3>
      <mat-form-field appearance="outline" class="full-width" >
        <mat-label>SQL Expression</mat-label>
        <textarea
        [errorStateMatcher]="errorStateMatcher"
          matInput
          rows="6"
          [value]="sqlExpression"
          formControlName="sqlExpression"
          readonly
          (click)="openSqlEditor()"
          placeholder="Click to open SQL editor"
        ></textarea>
        <mat-hint>Click on the text area to open SQL editor</mat-hint>
        <mat-error *ngIf="formulaForm.get('expression')?.hasError('required')">
            Expression is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- STATISTICAL MODE - SIDE BY SIDE LAYOUT -->
    <div [hidden]="mode !== 'Statistical'"  class="statistical-layout">
      <!-- Left Panel: Variables & Functions -->
      <div class="left-panel">
        <div class="panel-header">
          <mat-icon>build_circle</mat-icon>
          <span>Formula Builder</span>
        </div>

        <!-- Variables Section -->
        <div class="builder-section">
          <div class="section-title">
            <mat-icon>data_usage</mat-icon>
            <span>Variables</span>
          </div>
              <p-select
            [options]="variables"
            optionLabel="formulaName"
            optionValue="formulaName"
            placeholder="Select variable"
            [filter]="true"
             panelStyleClass="custom-pselect-panel"
         appendTo="body"
            [(ngModel)]="selectedVariable"
            [ngModelOptions]="{ standalone: true }"
            class="filter-dd"
            (onChange)="onVariableSelect($event.value)" >
          </p-select>
        </div>

                <!-- Operators Section -->
        <div class="builder-section">
          <div class="section-title">
            <mat-icon>calculate</mat-icon>
            <span>Operators</span>
          </div>
          <div class="operator-list">
            <button mat-raised-button *ngFor="let op of operators" 
                    (click)="insert(op)"
                    [matTooltip]="'Insert operator: ' + op">
              {{ op }}
            </button>
          </div>
        </div>

        <!-- Functions Section -->
        <div class="builder-section">
          <div class="section-title">
            <mat-icon>functions</mat-icon>
            <span>Functions</span>
          </div>
          <div class="function-list">
            <button mat-stroked-button *ngFor="let fn of functions" 
                    (click)="insertFunction(fn)"
                    [matTooltip]="fn.name + ' function'">
              {{ fn.display }}
            </button>
          </div>
        </div>


      </div>

      <!-- Right Panel: Expression Editor -->
      <div class="right-panel">
        <div class="panel-header">
          <mat-icon>edit_note</mat-icon>
          <span>Expression Editor</span>
        </div>
                          <!-- Quick Actions -->
        <div class="builder-actions" style="margin: 1rem; gap:0.5rem;display:flex;">
          <button mat-stroked-button (click)="clearFormula()" fullWidth>
            <mat-icon>delete_sweep</mat-icon>
            Clear
          </button>
          <button mat-stroked-button (click)="wrapWithParentheses()" fullWidth>
            <mat-icon>format_quote</mat-icon>
            Wrap ()
          </button>
        </div>

        <!-- Examples Dropdown -->
        <!-- <div class="examples-dropdown">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Quick Examples</mat-label>
            <mat-select (selectionChange)="useExample($event.value)">
              <mat-option *ngFor="let ex of formulaExamples" [value]="ex">
                {{ ex.name }}: {{ ex.formula }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->

        <!-- Expression Input -->
        <mat-form-field appearance="outline" class="full-width expression-input">
          <mat-label>Formula Expression</mat-label>
          <textarea
            #expressionTextarea
            matInput
            rows="4"
            formControlName="expression"
            placeholder="Start typing your formula here...&#10;Example: (A/(A+B))/(C/(C+D))"
            (keyup)="testFormula()"
          ></textarea>
          <mat-hint>
            <span>💡 Click on variables/functions from left panel to insert at cursor</span>
          </mat-hint>
         <mat-error *ngIf="formulaForm.get('expression')?.hasError('required')">
            Expression is required
          </mat-error>
    
        </mat-form-field>

        <!-- Variables Hint -->
        <!-- <div class="variables-hint">
          <mat-icon>info</mat-icon>
          <span>Available: <strong>{{ variables.join(", ") }}</strong></span>
        </div> -->

        <!-- Validation Results -->
        <div class="validation-panel" [class.valid]="isValid && formulaForm.get('expression')?.value" 
             [class.invalid]="!isValid && formulaForm.get('expression')?.value">
          <div class="validation-icon">
            <mat-icon *ngIf="!formulaForm.get('expression')?.value">info</mat-icon>
            <mat-icon *ngIf="formulaForm.get('expression')?.value && isValid">check_circle</mat-icon>
            <mat-icon *ngIf="formulaForm.get('expression')?.value && !isValid">error</mat-icon>
          </div>
          <div class="validation-message">
            {{ validationMessage || 'Enter a formula to test' }}
          </div>
          <div class="test-result" *ngIf="testResult !== null">
            <strong>Result:</strong> {{ testResult }}
            <span class="test-values" *ngIf="hasTestValues()">
              ({{ getTestValuesDisplay() }})
            </span>
          </div>
        </div>

        <!-- Test Button -->
        <div class="test-button-container">
          <button mat-raised-button color="primary" (click)="testFormula()" 
                  [disabled]="!formulaForm.get('expression')?.value" class="full-width">
            <mat-icon>play_arrow</mat-icon>
            Test Formula
          </button>
        </div>

                    <div *ngIf="mode === 'Statistical'" class="bottom-description">
              <mat-form-field appearance="outline" class="full-width" >
                <mat-label>Description</mat-label>
                <textarea matInput rows="2" formControlName="description" [errorStateMatcher]="errorStateMatcher"></textarea>
              </mat-form-field>
            </div>
      </div>
    </div>
  </div>
</form>

<!-- FOOTER -->
<mat-dialog-actions align="end" class="footer">
  <app-common-button
    label="Back"
    [buttonId]="1111"
    variant="cancel"
    width="110px"
    (clicked)="close()"
  >
  </app-common-button>

  <app-common-button
    label="Save"
    [buttonId]="1111"
    width="110px"
    (clicked)="saveFormula()"
  >
  </app-common-button>
</mat-dialog-actions>